export class URLUtils {
  static isValidURL(url: string): boolean {
    try {
      new URL(url)
      return true
    } catch (e) {
      return false
    }
  }

  static extractServiceUrl(
    service: { url: string | Record<string | 'default', string> } | undefined,
  ): string {
    if (!service || !('url' in service)) return ''

    const url = service.url
    return typeof url === 'string' ? url : (url?.default ?? '')
  }
}
